import Vue from 'vue';
import vSelect from 'vue-select';
import VueClipboard from 'vue-clipboard2';
import VueMeta from 'vue-meta';
import VTooltip from 'v-tooltip';
import Api from '@/plugins/Api';
import Dialogs from '@/plugins/Dialogs';
import { vuei18n } from '@/plugins/I18n';
import GlobalActions from '@/plugins/GlobalActions';
import InternalLinks from '@/plugins/InternalLinks';
import App from './App.vue';
import createRouter from './router/index';
import createStore from './store/index';

Vue.config.productionTip = false;
Vue.use(Api);
Vue.use(Dialogs);
Vue.use(VueClipboard);
Vue.component('v-select', vSelect);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});
Vue.use(VTooltip);
Vue.mixin({
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: `%s - ${this.BRAND_CONFIG.name}`,
      meta: [
        {
          name: 'description',
          content: vuei18n.t('SITE_DESCRIPTION'),
        },
        {
          name: 'keywords',
          content: vuei18n.t('SITE_KEYWORDS'),
        },
      ],
    };
  },
  data() {
    return {
      BRAND_KEY: process.env.BRAND_KEY,
      BRAND_CONFIG: process.env.BRAND_CONFIG,
    };
  },
});


function createApp() {
  const router = createRouter();
  Vue.router = Vue.observable(router);
  const store = createStore();
  Vue.store = Vue.observable(store);

  Vue.use(GlobalActions, { router });

  document.documentElement.classList.add(store.state.theme);

  const app = new Vue({
    router,
    store,
    i18n: vuei18n,
    render: h => h(App),
  });

  return { router, app };
}

export default createApp;
